import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { VideoRequestSummaryModel } from "./models/VideoRequestSummaryModel";

export type ListVideoRequestsRequest = {
  videoDate?: Date;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDesc?: boolean;
};

export type ListVideoRequestsResponse = {
  videoRequests: VideoRequestSummaryModel[];
  totalPages: number;
  totalRecords: number;
  requestsRemaining: number;
};

export const listVideoRequests = async (request: ListVideoRequestsRequest) => {
  const response = await executeApiRequest(async () => {
    return await axios.get<ListVideoRequestsResponse>(`/videorequests`, { params: request });
  });
  return response?.data;
};
